import { useParams, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useBlocker } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { QuoteConversationReturn } from '@/components/assistant/QuoteConversationReturn';
import { WorkOrderDetailContent } from './WorkOrderDetailContent';
import { navigateAwayFromWorkOrderDetail } from '@/lib/workOrderNavigation';

export default function WorkOrderDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const { t } = useTranslation('common');
  const [dirty, setDirty] = useState(false);
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      dirty && currentLocation.pathname !== nextLocation.pathname
  );

  const initialEditOpen = searchParams.get('edit') === 'true';

  const handleClose = () => {
    navigateAwayFromWorkOrderDetail(location.pathname, '/workorders', (to, options) => {
      void navigate(to, options);
    });
  };
  const handleEditOpened = () => {
    setSearchParams({}, { replace: true, state: location.state });
  };

  if (!id) return null;

  return (
    <>
      <QuoteConversationReturn quoteId={id} />
      <ConfirmDialog
        open={blocker.state === 'blocked'}
        title={t('unsavedChanges')}
        message={t('unsavedChangesMessage')}
        confirmText={t('discard')}
        onCancel={() => blocker.reset?.()}
        onConfirm={() => blocker.proceed?.()}
      />
      <WorkOrderDetailContent
        workOrderId={id}
        onClose={handleClose}
        initialEditOpen={initialEditOpen}
        onEditOpened={handleEditOpened}
        onDirtyStateChange={setDirty}
      />
    </>
  );
}
